import { useUIStore } from '@/stores/uiStore';
import MessageList from '@/components/messages/MessageList';
import SetList from '@/components/sets/SetList';
import TaskList from '@/components/tasks/TaskList';
import KitNav from '@/components/kit/KitNav';

export default function Sidebar() {
  const activeSection = useUIStore((s) => s.activeSection);

  return (
    <div className="flex h-full flex-col overflow-y-auto">
      {activeSection === 'messages' && <MessageList />}
      {activeSection === 'sets' && <SetList />}
      {activeSection === 'tasks' && <TaskList />}
      {activeSection === 'kit' && <KitNav />}
    </div>
  );
}
